import ReactGA from 'react-ga4'
export const DlcSteamLaunch = () => {
    return (
        <section className='max-w-[1000px] md:my-20 md:pb-20 mx-auto section-deco text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5  mt-12'>
            <div className='flex justify-center mt-20'>
                <img
                    className=''
                    alt='limited edition'
                    src={`${process.env.PUBLIC_URL}/images/dlc/header-dlc-steam-launch-fr.webp`}
                />
            </div>{' '}
            <h1 className='md:w-4/5 mx-auto mt-12'>
                Achetez l'édition de lancement jusqu'au 8 mai 2025 à 8 h (heure du Pacifique) pour obtenir gratuitement
                des bonus suivants :
            </h1>
            <div className='flex flex-col justify-center my-12 '>
                <h2 className='text-sm md:text-base text-center'>
                    <span className='text-pborange'>Bande-son originale</span> et{' '}
                    <span className='text-pborange'>tenue Minty pour Putty</span>
                </h2>
            </div>
            <div className='mt-8 flex justify-center max-w-[1000px] mx-auto'>
                <picture>
                    {' '}
                    <source
                        media='(max-width: 768px)'
                        srcSet={`${process.env.PUBLIC_URL}/images/dlc/dlc-steam-free-s-fr.webp`}
                    />
                    <img
                        className=''
                        alt='limited edition'
                        src={`${process.env.PUBLIC_URL}/images/dlc/dlc-steam-free-fr.webp`}
                    />
                </picture>
            </div>
            <h3 className='text-sub md:text-sm my-8'>
                La bande-son originale est aussi incluse dans{' '}
                <span className='text-pborange whitespace-nowrap'>Phantom Brave: The Lost Hero Deluxe Edition (Launch)</span>, aux côtés
                d'autres bonus incroyables !
            </h3>
            <button className='mb-12 md:mb-0 mt-4 w-full'>
                <a
                    target='_blank'
                    rel='noreferrer'
                    onClick={() => {
                        ReactGA.event({
                            action: 'click',
                            event: 'link',
                            category: 'Product',
                            label: 'Product - Steam - Steam',
                        })
                    }}
                    className='flex justify-center items-center text-center'
                    href='https://store.steampowered.com/agecheck/app/3049990/'
                >
                    {' '}
                    <img
                        className='w-full mx-atuo max-w-[270px] text-center'
                        alt='view on steam'
                        src={`${process.env.PUBLIC_URL}/images/dlc/view-on-steam-fr.webp`}
                    />
                </a>
            </button>
            {/* <div className='w-full lg:w-4/5  pb-8 text-center mx-auto my-12'>
                <iframe
                    title='phantom brave the lost hero'
                    src='https://store.steampowered.com/widget/3049990/'
                    style={{ maxWidth: '900px' }}
                    frameBorder='0'
                    width='100%'
                    height='190'
                    onClick={() => {
                        ReactGA.event({
                            action: 'click',
                            event: 'link',
                            category: 'Product',
                            label: 'Deluxe Ediiton - PC - Steam',
                        })
                    }}
                ></iframe>{' '}
            </div> */}
        </section>
    )
}
